import React from 'react';
import Input, { Props } from '.';
import { FieldRenderProps } from 'react-final-form';

export default (props: FieldRenderProps<Props, HTMLInputElement> & Props) => {
  const { input, meta, ...rest } = props;
  const error = meta.touched && (meta.error || meta.submitError);
  return <Input {...input} error={error} {...rest} />;
};
